import React from 'react'
import { FormattedMessage } from 'react-intl'

export const LACK = (resource) => (
    <FormattedMessage
        id='lack_of_industrial_resource.lack'
        defaultMessage='Не хватает {resource}'
        values={{ resource }}
    />
)

export const DESCRIPTION = (
    <FormattedMessage
        id='lack_of_industrial_resource.description'
        defaultMessage='Заработайте промресурс в Вылазках, Наступлениях или Случайных боях (на технике X уровня).' // eslint-disable-line max-len
    />
)



// WEBPACK FOOTER //
// ./components/LackOfIndustrialResource/constants.jsx